import PropTypes from 'prop-types';
import { makeAutoObservable } from 'mobx';
import React, { createContext, useContext } from 'react';
import { tacticMap } from '../../../../../../classes/tactics/tacticKeys';
import { validateForm } from './utils/validateForm';
import { returnData } from './utils/returnData';
export type Alert = {
  [index: string]: any;
  tradePlanId?: string;
  dataSource?: string;
  symbol?: string;
  goLong?: boolean;
  goShort?: boolean;
  restartSystemOncePositionHasFlattened?: boolean;
  restartSettings?: {
    deactivateOnRestart?: boolean;
  };
  setup: string;
  setupDetails?: any;
  setupFilters?: any;
  startHour?: number;
  startMin?: number;
  savedConfigurationTitle?: string;
  watchlistName?: string;
};

export interface AlertForm extends Alert {
  setFormToTemplate: () => void;
  setTradePlanId:() => void;
  setSymbol:() => void;
  setGoLong:() => void;
  setGoShort:() => void;
  setRestartSystemOncePositionHasFlattened:() => void;
  setDeactivateOnRestart:() => void;
  setSetup:() => void;
  addSetupFilter:() => void;
  removeSetupFilter:() => void;
  setWatchlistName:() => void;
  setDataSource:() => void;
  validate:() => void;
  resetToDefaults:() => void;
  dataObj:() => void;
}
type SetupFilters = {
  [index: string]: string;
};
type SetupDetails = {
  [index: string]: string;
};
export class AlertFormStore {
  tradePlanId = '';
  dataSource = 'LIVE';
  symbol = '';
  goLong = false;
  goShort = false;
  restartSystemOncePositionHasFlattened = false;
  restartSettings = {
    deactivateOnRestart: false,
  };
  setup = 'default';
  setupDetails: SetupDetails = {};
  setupFilters: SetupFilters = {};
  startHour = 9;
  startMin = 30;
  savedConfigurationTitle = null;
  watchlistName = 'default';

  constructor() {
    makeAutoObservable(this);
  }
  setFormToTemplate(json: Alert) {
    Object.keys(json).forEach((field) => {
      if (field === 'setupDetails') {
        if (json.setup !== 'default') {
          this.setupDetails = {
            [json.setup]: new tacticMap[json.setup].dataStore(
              json.setupDetails[json.setup]
            ),
          };
        } else {
          this.setupDetails = {};
        }
      } else if (field === 'setupFilters') {
        const filterArray = Object.keys(json.setupFilters);
        if (filterArray && filterArray.length > 0) {
          filterArray.forEach(
            (filter) =>
              (this.setupFilters[filter] = new tacticMap[filter].dataStore(
                json.setupFilters[filter]
              ))
          );
        } else {
          this.setupFilters = {};
        }
      } else this[field] = json[field];
    });
  }
  setTradePlanId(id: any) {
    this.tradePlanId = id;
  }
  setSymbol(string: string) {
    this.symbol = string;
  }
  setGoLong(bool: boolean) {
    this.goLong = bool;
  }
  setGoShort(bool: boolean) {
    this.goShort = bool;
  }
  setRestartSystemOncePositionHasFlattened(bool: boolean) {
    this.restartSystemOncePositionHasFlattened = bool;
  }
  setDeactivateOnRestart(bool: boolean) {
    this.restartSettings.deactivateOnRestart = bool;
  }
  setSetup(setup: any) {
    this.setup = setup;
    if (setup !== 'default') {
      this.setupDetails = {
        [setup]: new tacticMap[setup].dataStore(),
      };
    }
    if (setup !== 'CANDLE_PATTERN') {
      this.setDeactivateOnRestart(true);
    }
  }
  addSetupFilter(filter: string) {
    this.setupFilters[filter] = new tacticMap[filter].dataStore();
  }
  removeSetupFilter(filter: string) {
    delete this.setupFilters[filter];
  }
  setWatchlistName(name: string) {
    this.watchlistName = name;
  }
  setDataSource(string: string) {
    this.dataSource = string;
  }
  validate() {
    return validateForm(this);
  }
  resetToDefaults() {
    this.tradePlanId = '';
    this.symbol = '';
    this.goLong = false;
    this.goShort = false;
    this.restartSystemOncePositionHasFlattened = false;
    this.restartSettings = {
      deactivateOnRestart: false,
    };
    this.setup = 'default';
    this.setupDetails = {};
    this.setupFilters = {};
    this.startHour = 9;
    this.startMin = 30;
    this.savedConfigurationTitle = null;
    this.watchlistName = 'default';
  }
  get dataObj() {
    return returnData(this);
  }
}
interface FormContext extends AlertForm {
  value?: AlertForm;
}
interface ProviderProps {
  store: AlertForm;
  children?: JSX.Element | JSX.Element[];
}
const AlertFormContext = createContext<FormContext | null>(null);
export const useAlertFormStore = () => useContext(AlertFormContext);
export const AlertFormProvider: React.FC<ProviderProps> = ({ store, children }) => {
  return (
    <AlertFormContext.Provider value={store}>
      {children}
    </AlertFormContext.Provider>
  );
};

AlertFormProvider.propTypes = {
  children: PropTypes.any,
  store: PropTypes.any,
};
